// src/components/MachineInfo.jsx
import styles from "./MachineInfo.module.css";

function MachineInfo({machine}) {
  const machineStatus = machine.status || "Unknown";
  const statusClass = styles[`status_${machineStatus.toLowerCase()}`] || "";

  return (
    <div className={styles.machineInfoContainer}>
      <div className={styles.machineInfoText}>
        {machine.name} ({machine.country})
      </div>
      <div className={styles.machineInfoText}>{machine.serial_number}</div>
      <div className={styles.machineInfoText}>
        Status: <span className={`${styles.statusBadge} ${statusClass}`}>{machineStatus}</span>
      </div>
      <div className={styles.machineInfoText}>
        Job: <span className={styles.jobText}>{machine.job || "-"}</span>
      </div>
      <div className={styles.infoRow}>
        <span className={styles.label}>Mode: </span>
        <span className={styles.value}>{machine.shiftModel || "-"}</span>
      </div>
      <div className={styles.infoRow}></div>
    </div>
  );
}

export default MachineInfo;
